import { GridApiCommunity } from '@mui/x-data-grid/internals';

export type ItemTableGridApi<T = unknown> = GridApiCommunity & {
	flushTaskItems?: () => readonly T[];
};

export const flushItemTableItems = <T,>(apiRef: { current: ItemTableGridApi<T> | null }): readonly T[] | undefined =>
	apiRef.current?.flushTaskItems?.();